import React, { useEffect, useRef, useState } from "react";
import { View, Text, Image, Pressable, ScrollView } from "react-native";

import { CloseIcon, LeftChevron, RightChevron } from "../../utils/widgets/CommonWidget/Icons";

import AppStyles from "../../AppStyles";

import Colors from "../../utils/constants/AppColors";
import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";


class ImagesPreview extends React.Component<any, any> {

    constructor(props) {
        super(props)
        this.state = {
            imageIndex: 0,
            imagesList: props.route?.params?.imageList,
            showCloseIcon: props.route?.params?.showCloseIcon ?? true,
        }
    }



    closePreview = () => {
        this.props.navigation?.pop()
    }

    componentDidMount() {
        var calledEscape = false;

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                !calledEscape ? this.closePreview() : ''
                calledEscape = true;
            }

            if (event.keyCode == 37) {
                this.state.imageIndex == 0 ? '' : this.setState({ imageIndex: this.state.imageIndex - 1 })
            }

            if (event.keyCode == 39) {
                this.state.imagesList.length - 1 == this.state.imageIndex ? '' : this.setState({ imageIndex: this.state.imageIndex + 1 })
            }

        }, false);
    }

    render() {
        return (
            <ScrollView scrollEnabled={false}
                style={[AppStyles.fullScreenView, AppStyles.bgBlack,
                { height: AppTheme.modalHeight }]} >

                {this.state.showCloseIcon && <Pressable style={[AppStyles.topFix, AppStyles.mt24, {
                    alignItems: 'flex-end', paddingRight: 24
                }]} onPress={() => this.closePreview()}>
                    <CloseIcon action={() => { this.closePreview() }}
                        tintColor={Colors.white} /></Pressable>}

                <View style={[AppStyles.mx16, AppStyles.alignCenter, {
                    marginTop: 66, width: AppTheme.appWidth,
                    height: AppTheme.appHeight - 48 - 18 - 22 - 32
                }]}><Image resizeMode={'contain'}
                    source={{ uri: this.state.imagesList[this.state.imageIndex]?.imageUrl }}
                    style={[AppStyles.bgBlack, { width: AppTheme.appWidth - 32, aspectRatio: 1 }]} /></View>

                {this.state.imagesList.length > 1 ? <View style={[AppStyles.alignCenter, AppStyles.flexRowSpaceBetween,
                AppStyles.bottomFix, { bottom: 16 + 60, width: AppTheme.appWidth * 0.5 }]}>
                    <LeftChevron disabled={this.state.imageIndex == 0} resize={2}
                        action={() => { this.setState({ imageIndex: this.state.imageIndex - 1 }) }} />
                    <Text style={[TextStyle.text16, { color: Colors.white }]}>
                        {this.state.imageIndex + 1}/{this.state.imagesList.length}</Text>
                    <RightChevron disabled={this.state.imagesList.length - 1 == this.state.imageIndex} resize={2}
                        action={() => { this.setState({ imageIndex: this.state.imageIndex + 1 }) }} />
                </View> : null}

            </ScrollView>
        );
    }
}

export default ImagesPreview

